import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';
import type {
    DeleteTemplatesApiRequest,
    GetTemplatesApiResponse,
} from 'tradera/state/services/types/webapi-selling-generated';

export enum Tags {
    TEMPLATES_LIST = 'TEMPLATES_LIST',
}

export const templatesApi = createApi({
    reducerPath: 'templatesApi',
    baseQuery: isomorphicWebApiBaseQuery,
    tagTypes: Object.keys(Tags),
    endpoints: (builder) => ({
        deleteTemplate: builder.mutation<void, DeleteTemplatesApiRequest>({
            invalidatesTags: [Tags.TEMPLATES_LIST],
            query: (parameters) => {
                return {
                    url: '/api/webapi/selling/templates',
                    method: 'DELETE',
                    body: parameters,
                };
            },
        }),
        loadTemplates: builder.query<GetTemplatesApiResponse, void>({
            providesTags: [Tags.TEMPLATES_LIST],
            query: () => '/api/webapi/selling/templates?take=100',
        }),
    }),
});

export const { useDeleteTemplateMutation, useLoadTemplatesQuery, util } =
    templatesApi;
